module.exports = __webpack_public_path__ + "static/img/banner-textnew.eafdda0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-textnew.png
// module id = Fg7r
// module chunks = 1